import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import { HttpFileService } from '../http-file.service';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.csv';
import * as FileSaver from 'file-saver'
import { Observable, Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import { cloneDeep } from 'lodash';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public httpClient: HttpClient,
    public httpFileService: HttpFileService,
    private router: Router
  ) { }
  user_list(payload: any) {
    return this.httpService.post(`admin/user/user_list`, payload);
  }
  shell_user_list(payload: any) {
    return this.httpService.post(`admin/user/shell_user_list`, payload);
  }

  intakeForms(payload: any) {
    return this.httpService.post(`admin/get/intake_users`, payload);
  }

  setStatus(payload: any) {
    return this.httpService.post(
      `admin/update/update_intake_user_status`,
      payload
    );
  }

  setGroup(payload: any) {
    return this.httpService.post(`admin/assign/user_group`, payload);
  }

  addNewGroup(payload: any) {
    return this.httpService.post(`admin/add/add_group`, payload);
  }

  addNote(payload: any) {
    return this.httpService.post(`admin/add/user/note`, payload);
  }

  editNote(payload: any) {
    return this.httpService.post(`admin/update/user/note`, payload);
  }

  get_direct_prescription(payload: any) {
    return this.httpService.post(
      `admin/get/user/uploaded_prescriptions`,
      payload
    );
  }

  get_transfer_prescription(payload: any) {
    return this.httpService.post(
      `admin/get/user/transfer_prescriptions`,
      payload
    );
  }


  saveTransferPrescriptionStatus(payload: any) {
    return this.httpService.post(`admin/medscheck/save_transfer_prescription_status`,payload);
  }
  userById(id: any) {
    return this.httpService.post(`admin/get/user/detail`, { user_id: id });
  }
  shell_userById(id: any) {
    return this.httpService.post(`admin/get/shell_user/detail`, { user_id: id });
  }

  patientOverview(id: any) {
    return this.httpService.post(`admin/get/user/overview`, { user_id: id });
  }

  getAllStatus() {
    return this.httpService.post(`admin/get/get_all_intake_user_status`, '');
  }

  getAllGroups() {
    return this.httpService.post(`admin/get/get_all_groups`, '');
  }

  update_refill_request_status(payload: any) {
    return this.httpService.post(
      `admin/user/update_refill_request_status`,
      payload
    );
  }

  linkAccount(payload: any) {
    return this.httpService.post(`admin/add/existing_profile`, payload);
  }

  getRelations() {
    return this.httpService.post(`admin/get/relationsips`, {});
  }

  bulk_update_status(payload: any[]) {
    return this.httpService.post(`admin/bulk_update_status`, payload);
  }
  send_push_notification(payload: any) {
    return this.httpService.post(`admin/user/send_push_notification`, payload);
  }
  toggle_notification_reminder(payload: any) {
    return this.httpService.post(
      `admin/user/toggle_notification_reminder`,
      payload
    );
  }
  get_user_medication_list(payload: any) {
    return this.httpService.post(
      `admin/user/get_user_medication_list`,
      payload
    );
  }

  get_user_added_medication(payload: any) {
    return this.httpService.post(`admin/get/user/get_medicine_list`, payload);
  }

  get_upcoming_appointment(payload: any) {
    return this.httpService.post(
      `admin/get/user/get_user_oppointments`,
      payload
    );
  }

  get_notes(payload: any) {
    return this.httpService.post(`admin/get/user/notes`, payload);
  }

  // get_user_added_meds(payload: any) {
  //   return this.httpService.post(
  //     `admin/get/user/get_user_oppointments`,
  //     payload
  //   );
  // }

  get_patient_order(payload: any) {
    return this.httpService.post(`admin/get/user/get_user_orders`, payload);
  }
  get_renew_refill_status(payload: any) {
    return this.httpService.post(`admin/user/get_renew_refill_status`, payload);
  }
  get_rejected_reason(payload: any) {
    return this.httpService.post(`admin/rejected_reason/get`, payload);
  }
  save_rejected_reason(payload: any) {
    return this.httpService.post(`admin/rejected_reason/create`, payload);
  }
  medication_sync(payload: any) {
    return this.httpService.post(`admin/user/medication_sync`, payload);
  }
  all_users_medications_sync(payload: any) {
    return this.httpService.post(
      `admin/user/all_users_medications_sync`,
      payload
    );
  }
  updateAutoRefill(obj: any) {
    return this.httpService.post(
      'admin/medication/update_auto_refill_request',
      obj
    );
  }
  get_status_messages(obj: any) {
    return this.httpService.post('admin/medication/get_status_messages', obj);
  }
  get_checkbox_message_templates(obj: any) {
    return this.httpService.post(
      'admin/medication/get_checkbox_message_templates',
      obj
    );
  }
  get_all_refill_list(obj: any) {
    return this.httpService.post('admin/user/get_all_refill_list', obj);
  }
  viewPdf(obj: any) {
    return this.httpService.post('admin/get/intake_user_pdf', obj);
  }

  removeNote(payload: any) {
    return this.httpService.post(`admin/delete/user/note`, payload);
  }
  getFeatureFlag() {
    return this.httpService.get(`admin/get/features`);
  }
  updateFeatureFlag(obj: any) {
    return this.httpService.post(`admin/update/feature`, obj);
  }
  disableMFA(obj: any) {
    return this.httpService.post(`admin/user/mfa/disable`, obj);
  }
  getSurveyList(obj: any) {
    return this.httpService.post(`admin/survey/user/list`, obj);
  }
  getConditionList() {
    return this.httpService.get(`admin/survey/list`)
  }
  getConsentList(obj: any) {
    return this.httpService.post(`admin/consent/get`, obj);
  }
  addConsent(obj: any) {
    if (!obj.id) {
      return this.httpService.postForConsentHtml(`admin/consent/add`, obj);
    } else {
      return this.httpService.postForConsentHtml(`admin/consent/update`, obj);
    }
  }
  updateConsent(obj: any) {
    return this.httpService.postForConsentHtml(`admin/consent/update`, obj);
  }
  updateConsentStatus(obj: any) {
    return this.httpService.post(`admin/consent/update/status`, obj);
  }

  getConsentReport(obj: any) {
    return this.httpService.post(`admin/consent/view/report`, obj);
  }

  exportAsExcelFile(json: any[], excelFileName: string, date: any): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    // console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    // const excelBuffer: any = XLSX.write(workbook, { bookType: 'csv', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName, date);
  }

  exportAsEncodedCSV(json: any[], excelFileName: string, date?: any): void {
    if (date != null) {
      // const formattedDate =('0' + date.getDate()).slice(-2) +('0' + (date.getMonth() + 1)).slice(-2) +date.getFullYear() +'_' +
      // ('0' + date.getHours()).slice(-2) +'_' +('0' + date.getMinutes()).slice(-2) +'_' +('0' + date.getSeconds()).slice(-2);

      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear().toString();
      const formattedDate = `${month}${day}${year}`;

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
      const csv: string = XLSX.utils.sheet_to_csv(worksheet, { FS: ',', RS: '\n' });
      const csvData: Uint8Array = new TextEncoder().encode(csv);
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, excelFileName + formattedDate + '.csv');
    } else {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
      const csv: string = XLSX.utils.sheet_to_csv(worksheet, { FS: ',', RS: '\n' });
      const csvData: Uint8Array = new TextEncoder().encode(csv);
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, excelFileName + '.csv');
    }
  }

  saveAsExcelFile(buffer: any, fileName: string, date: any): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + date + EXCEL_EXTENSION);
  }

  // Promo Code

  getPromoCodeList(obj: any) {
    return this.httpService.post(`admin/promo/code/list`, obj);
  }
  createPromoCode(obj: any) {
    return this.httpService.post(`admin/promo/code/create`, obj);
  }
  deletePromoCode(obj: any) {
    return this.httpService.post(`admin/promo/code/delete`, obj);
  }
  deleteSaleOrderPromoCode(obj: any) {
    return this.httpService.post(`admin/sales/order/remove/promo`, obj);
  }
  updatePromoStatus(obj: any) {
    return this.httpService.post(`admin/promo/code/status/update`, obj);
  }
  getUserPromoCodeList(obj: any) {
    return this.httpService.post(`admin/user/promo/code/list`, obj);
  }
  addUserPromoCode(obj: any) {
    return this.httpService.post(`admin/user/promo/code/add`, obj);
  }
  getActivePromoCodeList(obj: any) {
    return this.httpService.post(`admin/promo/code/active/list`, obj);
  }
  viewUsedPromoReportForUsers(obj: any) {
    return this.httpService.post(`admin/promo/code/usage`, obj);
  }

  // low activity reason
  lowActivityReasonById(id: any) {
    return this.httpService.post(`admin/reason/get`, { user_id: id });
  }

  private lowActiveReasonAction = new Subject<any>();
  getLowActiveReasonProfile = this.lowActiveReasonAction.asObservable();

  setValueToShowLowActiveReason(obj: any) {
    this.lowActiveReasonAction.next(obj)
  }

  assignLowActivityReason(payload: any) {
    return this.httpService.post('admin/reason/assign', payload);
  }

  // user report

  getUserReport(obj: any) {
    return this.httpService.post(`admin/report/get`, obj);
  }

  getDashboardCount(obj: any) {
    return this.httpService.post(`admin/dashboard/counts`, obj);
  }

  private urlWithActionRenewRefill = new Subject<any>();
  getCurrentUrlRenewRefill = this.urlWithActionRenewRefill.asObservable();

  setUrlWithActionRenewRefill(obj: any) {
    this.urlWithActionRenewRefill.next(obj)
  }

  private urlWithActionSalesOrder = new Subject<any>();
  getCurrentUrlSalesOrder = this.urlWithActionSalesOrder.asObservable();

  setUrlWithActionSalesOrder(obj: any) {
    this.urlWithActionSalesOrder.next(obj)
  }

  private urlWithPexchange = new Subject<any>();
  getCurrentUrlPexchamge = this.urlWithPexchange.asObservable();

  setUrlWithPexchange(obj: any) {
    this.urlWithPexchange.next(obj)
  }

  private urlWithActionProcessOrder = new Subject<any>();
  getCurrentUrlProcessOrder = this.urlWithActionProcessOrder.asObservable();

  setUrlWithActionProcessOrder(obj: any) {
    this.urlWithActionProcessOrder.next(obj)
  }

  private urlWithAppUsers = new Subject<any>();
  getCurrentUrlAppUsers = this.urlWithAppUsers.asObservable();

  setUrlWithAppUsers(obj: any) {
    this.urlWithAppUsers.next(obj)
  }

  prescription_list(payload: any) {
    return this.httpService.post(`admin/user/prescriptions`, payload);
  }
  prescriptionAllStatusList(payload: any = "") {
    return this.httpService.post(`admin/prescription-all-status-list`, payload);
  }

  customPrescriptionStatusList(payload: any = "") {
    return this.httpService.post(`admin/upload-prescription-status-list`, payload);
  }

  transferPrescriptionAllStatusList(payload: any = "") {
    return this.httpService.post(`admin/transfer-prescription-all-status-list`, payload);
  }
  tpStatusUrgencyList(payload: any = "") {
    return this.httpService.post(`admin/transfer-prescription-status-with-urgency-list`, payload);
  }

  downloadReportCsv(payload: any) {
    return this.httpService.post(`admin/report/download`, payload);
  }

  downloadMemberReport(payload: any) {
    return this.httpService.post(`admin/report/generateSlfinanaceReport`, payload);
  }

  downloadNonMemberReport(payload: any) {
    return this.httpService.post(`admin/report/generateNonslfinanaceReport`, payload);
  }

  getEventTypes() {
    return this.httpService.post(`admin/report/geteventtypes`, null);
  }

  getRefreshCalendlyData() {
    return this.httpService.post(`admin/report/refreshcalendlydata`, null);
  }

  getLastRefreshData() {
    return this.httpService.post(`admin/report/getlastrefresheddata`, null);
  }

  getandGenerateFreetrial() {
    return this.httpService.post(`admin/report/getandGenerateFreetrial`, null);
  }

  getMembersCompletingModule() {
    return this.httpService.post(`admin/report/getMembersCompletingModule`, null);
  }

  getMembersModuleCompleted() {
    return this.httpService.post(`admin/report/getMembersModuleCompleted`, null);
  }

  getCalendlyEventData(data: any) {
    return this.httpService.post(`admin/report/getcalendlyeventdata`, data);
  }

  lastGeneratedUserInfo(payload: any) {
    return this.httpService.post(`admin/report/lastgenerateduserinfo`, payload);
  }

  generateUserInfo(payload: any) {
    return this.httpService.post(`admin/report/generateuserinfo`, payload);
  }

  prescriptionChangeStatusList(payload: any = "") {
    return this.httpService.post(`admin/prescription-status-change-list`, payload);
  }

  transferPrescriptionChangeStatusList(payload: any = "") {
    return this.httpService.post(`admin/transfer-prescription-status-change-list`, payload);

  }
  stateList(payload: any = "") {
    return this.httpService.post(`admin/get/state-list`, payload);

  }
  useredit(payload: any = "") {
    return this.httpService.post(`admin/user/edit`, payload);
  }
  updateUser(payload: any) {
    return this.httpService.post(`admin/user/update`, payload);
  }
  updatePassword(payload: any) {
    return this.httpService.post(`admin/user/update-password`, payload);
  }
  updatePincode(payload: any) {
    return this.httpService.post(`admin/user/update-pincode`, payload);
  }

  getAddresses(payload: any) {
    return this.httpService.post(`admin/user/address-list`, payload);
  }
  getUserDetail(payload: any) {
    return this.httpService.post(`admin/user/chat`, payload);
  }
  userAdd(payload: any = "") {
    return this.httpService.post(`admin/user/store`, payload);
  }

  pendingCheckStatusUpdate(payload: any) {
    return this.httpService.post(`admin/user/chat/pending/update`, payload);
  }
  recentPaymentsList(payload: any) {
    return this.httpService.post(`admin/get/user/recent/payments`, payload);
  }
  pendingPaymentsList(payload: any) {
    return this.httpService.post(`admin/get/user/pending/payment/server_processing`, payload);
  }
  getUserAllergiesList(payload: any) {
    return this.httpService.post(`admin/user/allergies/list`, payload);
  }
  removeUserAllergies(payload: any) {
    return this.httpService.post(`admin/user/allergies/delete`, payload);
  }
  getUserMedicalConditionsList(payload: any) {
    return this.httpService.post(`admin/user/medical-conditions/list`, payload);
  }
  removeUserMedicalConditions(payload: any) {
    return this.httpService.post(`admin/user/medical-conditions/delete`, payload);
  }
  getSingle(payload: any) {
    return this.httpService.post(`admin/user/get_single`, payload);
  }
  userAccountEnableDisable(payload: any) {
    return this.httpService.post(`admin/user/account/enable-disable`, payload);
  }

  userAccountDelete(payload: any) {
    return this.httpService.post(`admin/user/delete`, payload);
  }

  userPacketsSync(payload: any) {
    return this.httpService.post(`admin/user/packets/sync`, payload);
  }
  userAgreementSend(payload: any) {
    return this.httpService.post(`admin/user/agreement-send`, payload);
  }
  userMedicationsPaymentList(payload: any) {
    return this.httpService.post(`admin/user/medications/payment/list`, payload);
  }
  userAddedCardList(payload: any) {
    return this.httpService.post(`admin/user/added/card`, payload);
  }
  // Additional Coverage
  getAdditionalCoverageList(obj: any) {
    return this.httpService.post(`admin/additional/coverage/list`, obj);
  }
  createAdditionalCoverage(obj: any) {
    return this.httpService.post(`admin/additional/coverage/create`, obj);
  }

  updateAdditionalCoverageStatus(obj: any) {
    return this.httpService.post(`admin/additional/coverage/status/update`, obj);
  }
  deleteAdditionalCoverageStatus(obj: any) {
    return this.httpService.post(`admin/additional/coverage/delete`, obj);
  }
  detailAdditionalCoverage(id: any) {
    return this.httpService.post(`admin/additional/coverage/detail/${id}`, {});
  }
  userMedicationsPaymentAdd(payload: any) {
    return this.httpService.post(`admin/user/medications/payment/add`, payload);
  }
  userMedicationsPaymentEdit(payload: any) {
    return this.httpService.post(`admin/user/medications/payment/edit`, payload);
  }
  editAdditionalCoverage(obj: any) {
    return this.httpService.post(`admin/additional/coverage/update`, obj);
  }
  removeUserAddedCard(payload: any) {
    return this.httpService.post(`admin/user/delete/card`, payload);
  }
  userMedicationsPaymentDelete(payload: any) {
    return this.httpService.post(`admin/user/medications/payment/delete`, payload);
  }
  userMedicationsPaymentStatusUpdate(payload: any) {
    return this.httpService.post(`admin/user/medications/payment/status-update`, payload);
  }
  userPacketsList(payload: any) {
    return this.httpService.post(`admin/user/packets/list`, payload);
  }
  getUserInsuranceList(payload: any) {
    return this.httpService.post(`admin/user/insurance`, payload);
  }
  getUserTwilioMessageList(payload: any) {
    return this.httpService.post(`admin/user/twilio/chat/list`, payload);
  }
  sendUserTwilioMessage(payload: any) {
    return this.httpService.post(`admin/user/twilio/message/send`, payload);
  }
  allBrodcastUsersList(payload: any = "") {
    return this.httpService.post(`admin/user/broadcasting/list`, payload);

  }
  sendBrodcastMessage(payload: any = "") {
    return this.httpService.post(`admin/user/broadcasting/send-message`, payload);
  }
  drugsAutocomplete(payload: any = "") {
    return this.httpService.post(`admin/drugs/autocomplete`, payload);
  }
  userPacketsAdd(payload: any = "") {
    return this.httpService.post(`admin/user/packets/add`, payload);
  }
  userPacketsEdit(payload: any = "") {
    return this.httpService.post(`admin/user/packets/update_edit_new`, payload);
  }
  deleteUserPackets(payload: any = "") {
    return this.httpService.post(`admin/user/fs/packet/delete`, payload);
  }
  userPacketsVewEdit(payload: any = "") {
    return this.httpService.post(`admin/user/packets/vew_edit_new`, payload);
  }
  getPatientAppFormData(payload: any = "") {
    return this.httpService.post(`admin/get/medscheck/user_pre_assessment_details`, payload);
  }
  getPharmacistQuestions(payload: any = "") {
    return this.httpService.post(`admin/medscheck/get_pharmacist_questions`, payload);
  }
  getRepeatAstCatScore(payload: any = "") {
    return this.httpService.post(`admin/medscheck/repeat_ast_cat_score`, payload);
  }
  transfer_prescription_list(payload: any = "") {
    return this.httpService.post(`admin/user/transfer-prescriptions-all-list`, payload);
  }
  savePharmacistAnswers(payload: any) {
    return this.httpService.post(`admin/medscheck/save_pharmacist_answers`, payload);
  }

  updateFollowUpQuestions(payload: any) {
    return this.httpService.post(`admin/medscheck/update_followup_questions`, payload);
  }

  getActionPlan(payload: any) {
    return this.httpService.post(`admin/medscheck/get_action_plan`, payload);
  }

  changeActionPlan(payload: any) {
    return this.httpService.post(`admin/medscheck/change_action_plan`, payload);
  }

  addActionPlan(payload: any) {
    return this.httpService.post(`admin/medscheck/actionplan/add`, payload);

  }

  generatePdf(payload: any) {
    return this.httpService.post(`admin/medscheck/generate_action_plan_pdf`, payload);
  }
  uploadPdf(payload: FormData, options: any) {
    return this.httpFileService.post(`admin/medscheck/copd_antibiotic_rx_template`, payload, options);
  }

  addmedicationtouser(payload: any) {
    return this.httpService.post(`admin/manual/addmedicationtouser`, payload);
  }
  saveNotification(payload: any) {
    return this.httpService.post(`admin/user/save_notification`, payload);
  }

  deletionRequestList(payload: any) {
    return this.httpService.post(`admin/user/deletion-request/list`, payload);
  }
  deletionRequestApproved(payload: any) {
    return this.httpService.post(`admin/user/deletion-request/approved`, payload);
  }

  deletionRequestReject(payload: any) {
    return this.httpService.post(`admin/user/deletion-request/reject`, payload);
  }

  deletionRequestCustomMessage(payload: any) {
    return this.httpService.post(`admin/user/deletion-request/custom-message`, payload);
  }


  //*** */
  getFollowupMedication(payload: any) {
    return this.httpService.post(`admin/medscheck/get_followup_medication`, payload);
  }

  saveFollowupMedication(payload: any) {
    return this.httpService.post(`admin/medscheck/save_followup_medication`, payload);
  }

  //  ***** //
  GetOverallAssessmentQuestions(payload: any) {
    return this.httpService.post(`admin/medscheck/get_overall_assessment_questions`, payload);
  }

  //P exchange service
  exchange_data_list(payload: any) {
    return this.httpService.post(`admin/get/pexchange-prescriptions`, payload);
  }

  clientList(payload: any) {
    return this.httpService.post(`admin/client/list-all`, payload);
  }

  filterpexchangeStatusAll(payload: any) {
    return this.httpService.post(`admin/get/pexchange-prescriptions/status-all`, payload);
  }


  pexchangeUserDetail(payload: any) {
    return this.httpService.post(`admin/get/pexchange-prescriptions/detail`, payload);
  }

  reasonListAll(payload: any) {
    return this.httpService.post(`admin/prescription/reason/list-all`, payload);
  }

  pexchangeStatusUpdate(payload: any) {
    return this.httpService.post(`admin/pexchange-prescriptions/status-update`, payload);
  }

  tablePexchangeStatus(payload: any) {
    return this.httpService.post(`admin/get/pexchange-prescriptions/status-change-list`, payload);
  }

  prescriptionsMove(payload: any) {
    return this.httpService.post(`admin/prescriptions/move`, payload);
  }

  clinetListDD(payload: any) {
    return this.httpService.post(`admin/client/list-all-for-dd`, payload);
  }

  quickUpdate(payload: FormData, options: any) {
    return this.httpFileService.post(`admin/pexchange-prescriptions/quick-update`, payload, options);
  }

  // addNewQuickUser(payload: any) {
  //   return this.httpService.post(`admin/pexchange-prescriptions/create`,payload);
  // }

  addNewQuickUser(payload: FormData, options: any) {
    return this.httpFileService.post(`admin/pexchange-prescriptions/create`, payload, options);
  }

  SaveOverallAssessmentAnswers(payload: any) {
    return this.httpService.post(`admin/medscheck/save_overall_assessment_answers`, payload);
  }
  getTodayDiscussionSummary(payload: any = "") {
    return this.httpService.post(`admin/medscheck/today_discussion_summary`, payload);
  }
  saveTodayDiscussionSummary(payload: any = "") {
    return this.httpService.post(`admin/medscheck/add_today_discussion_summary`, payload);
  }
  saveDcpMedicationReviewQus(payload: any = "") {
    return this.httpService.post(`admin/medscheck/add_reduce_cv_risks`, payload);
  }
  getDcpMedicationReviewQus(payload: any = "") {
    return this.httpService.post(`admin/medscheck/get_reduce_cv_risks`, payload);
  }

  getResourcesProvided(payload: any = "") {
    return this.httpService.post(`admin/medscheck/get_resources_provided`, payload);
  }

  addResourcesProvided(payload: any = ""){
    return this.httpService.post(`admin/medscheck/add_resources_provided`, payload);
  }

  saveReferals(payload: any = "") {
    return this.httpService.post(`admin/medscheck/save_referals`, payload);
  }

  getReferals(payload: any = "") {
    return this.httpService.post(`admin/medscheck/get_referals`, payload);
  }

  saveDcpDiabetesAssessment(_payload: any = "") {
    var payload = cloneDeep(_payload)
    if (payload && payload?.question_data) {
      if (payload?.question_data?.radio_val) {
        payload.question_data.radio_val = encodeURIComponent(payload?.question_data?.radio_val)
      }
      if (payload?.question_data?.notes) {
        payload.question_data.notes = encodeURIComponent(payload?.question_data?.notes)
      }
      if (payload?.question_data?.radio_assigned_val) {
        payload.question_data.radio_assigned_val = encodeURIComponent(payload?.question_data?.radio_assigned_val)
      }
      if (payload?.question_data?.symbolic_val) {
        payload.question_data.symbolic_val = encodeURIComponent(payload?.question_data?.symbolic_val)
      }
      if (payload?.question_data?.diastolic_val) {
        payload.question_data.diastolic_val = encodeURIComponent(payload?.question_data?.diastolic_val)
      }
      if (payload?.question_data?.txt_value) {
        payload.question_data.txt_value = encodeURIComponent(payload?.question_data?.txt_value)
      }
      if (payload?.question_data?.radio_per_min_val) {
        payload.question_data.radio_per_min_val = encodeURIComponent(payload?.question_data?.radio_per_min_val)
      }
      if (payload?.question_data?.speak_dietitian_val) {
        payload.question_data.speak_dietitian_val = encodeURIComponent(payload?.question_data?.speak_dietitian_val)
      }
      if (payload?.question_data?.patient_reason) {
        payload.question_data.patient_reason = encodeURIComponent(payload?.question_data?.patient_reason)
      }
      if (payload?.question_data?.consultation_summary) {
        payload.question_data.consultation_summary = encodeURIComponent(payload?.question_data?.consultation_summary)
      }
      if (payload?.question_data?.dietitian_val) {
        payload.question_data.dietitian_val = encodeURIComponent(payload?.question_data?.dietitian_val)
      }
      if (payload?.question_data?.glucose_check_from_val) {
        payload.question_data.glucose_check_from_val = encodeURIComponent(payload?.question_data?.glucose_check_from_val)
      }
      if (payload?.question_data?.hyp_mgmt_val) {
        payload.question_data.hyp_mgmt_val = encodeURIComponent(payload?.question_data?.hyp_mgmt_val)
      }
      if (payload?.question_data?.driving_awareness_val) {
        payload.question_data.driving_awareness_val = encodeURIComponent(payload?.question_data?.driving_awareness_val)
      }
      if (payload?.question_data?.lab_work_reason) {
        payload.question_data.lab_work_reason = encodeURIComponent(payload?.question_data?.lab_work_reason)
      }
      if (payload?.question_data?.foot_care_reason) {
        payload.question_data.foot_care_reason = encodeURIComponent(payload?.question_data?.foot_care_reason)
      }
      if (payload?.question_data?.eye_care_reason) {
        payload.question_data.eye_care_reason = encodeURIComponent(payload?.question_data?.eye_care_reason)
      }
      if (payload?.question_data?.sick_day_reason) {
        payload.question_data.sick_day_reason = encodeURIComponent(payload?.question_data?.sick_day_reason)
      }
      if (payload?.question_data?.insulin_reason) {
        payload.question_data.insulin_reason = encodeURIComponent(payload?.question_data?.insulin_reason)
      }
      if (payload?.question_data?.about_quitting_val) {
        payload.question_data.about_quitting_val = encodeURIComponent(payload?.question_data?.about_quitting_val)
      }
      if (payload?.question_data?.glucose_variability) {
        payload.question_data.glucose_variability = encodeURIComponent(payload?.question_data?.glucose_variability)
      }
      if (payload?.question_data?.sensor_val) {
        payload.question_data.sensor_val = encodeURIComponent(payload?.question_data?.sensor_val)
      }
      if (payload?.question_data?.gmi_val) {
        payload.question_data.gmi_val = encodeURIComponent(payload?.question_data?.gmi_val)
      }
      if (payload?.question_data?.tir_val) {
        payload.question_data.tir_val = encodeURIComponent(payload?.question_data?.tir_val)
      }
      if (payload?.question_data?.tbr_val) {
        payload.question_data.tbr_val = encodeURIComponent(payload?.question_data?.tbr_val)
      }
      if (payload?.question_data?.tar_val) {
        payload.question_data.tar_val = encodeURIComponent(payload?.question_data?.tar_val)
      }
      if (payload?.question_data?.radio_title) {
        payload.question_data.radio_title = encodeURIComponent(payload?.question_data?.radio_title)
      }
    }
    return this.httpService.post(`admin/medscheck/save_diabetes_assessment`, payload);
  }

  getDcpDiabetesAssessment(payload: any = "") {
    return this.httpService.post(`admin/medscheck/get_diabetes_assessment`, payload);
  }
  getPatientLifestyleRX(payload: any = "") {
    return this.httpService.post(`admin/medscheck/patient_life_style_rx`, payload);
  }
  startAdhocConsultaion(payload: any = "") {
    return this.httpService.post(`admin/medscheck/start_adhoc_consultaion`, payload);
  }

  // getServerLoaction(payload: any = "") {
  //   return this.httpService.post(`admin/user/getserverloaction`, payload);
  // }

  prescriptionsAddUpload(payload: any = "") {
    return this.httpService.post(`admin/tp/prescriptions/add_or_upload`, payload);
  }

  getServerLoaction(payload: any = "") {
    return this.httpService.post(`admin/user/getserverloaction`, payload);
  }
  VerifyUserKrollid(payload: any = "") {
    return this.httpService.post(`admin/user/verify-user-krollid`, payload);
  }


  addKeyEducationPoints(payload: any = "") {
    return this.httpService.post(`admin/medscheck/led/add_key_education_points`, payload);
  }
  getKeyEducationPoints(payload: any = "") {
    return this.httpService.post(`admin/medscheck/led/get_key_education_points`, payload);
  }
   getLedBackground(payload: any = "") {
    return this.httpService.post(`admin/medscheck/led/led_background`, payload);
  }
  downloadResourcesProvided(payload: any = "") {
    return this.httpService.post(`admin/medscheck/led/get_resources_pdf`, payload);
  }

  getDeletionReasons(payload: any = "") {
    return this.httpService.post(`admin/user/get_delete_reason`, payload);
  }

  getProgramList(payload: any = "") {
    return this.httpService.post(`admin/referral-code/program-list`, payload);
  }

  addUserDeleteReason(payload: any = "") {
    return this.httpService.post(`admin/prescription/reason/add`, payload);
  }

  getScPatientQuestions(payload: any = "") {
    return this.httpService.post(`admin/medscheck/smoking/get-sc-patient-questions`, payload);
  }
    saveScPatientQuestions(payload: any = "") {
    return this.httpService.post(`admin/medscheck/smoking/save-sc-patient-questions`, payload);
  }
  shell_prescription_list(payload: any = "") {
    return this.httpService.post(`admin/shell/prescriptions`, payload);
  }
  adminEprescriptions(payload: any) {
    return this.httpService.post(`admin/e-prescriptions`, payload);
  }
  userEprescriptions(payload: any) {
    return this.httpService.post(
      `admin/get/user/e_prescriptions`,
      payload
    );
  }
  adminDialogueEprescriptions(payload: any) {
    return this.httpService.post(`admin/dialogue-prescriptions`, payload);
  }
  getpharmacistAssessment(payload: any = "") {
    return this.httpService.post(`admin/medscheck/assessment/get-pharmacist-assessment`, payload);
  }
  savePharmacistAssessment(payload: any = "") {
    return this.httpService.post(`admin/medscheck/assessment/save-pharmacist-assessment`, payload);
  }
  userAddedCardListMoneris(payload: any) {
    return this.httpService.post(`admin/moneris/get_cards`, payload);
  }
  removeUserAddedCardMoneris(payload: any) {
    return this.httpService.post(`admin/moneris/delete`, payload);
  }
  userMedicationsPaymentAddMoneris(payload: any) {
    return this.httpService.post(`admin/moneris/add_user_payment`, payload);
  }
  userMedicationsPaymentEditMoneris(payload: any) {
     return this.httpService.post(`admin/user/medications/payment/edit`, payload);
  }
  userMedicationsPaymentStatusUpdateMoneris(payload: any) {
    return this.httpService.post(`admin/moneris/update_user_payment`, payload);
  }
  getCqpNpnList(obj: any) {
    return this.httpService.post(`admin/promo/cqp-npn-list`, obj);
  }
  getPharmicistKeyEdu(payload: any = "") {
    return this.httpService.post(`admin/medscheck/assessment/get-Key-education-points`, payload);
  }

  addPharmicistKeyEdu(payload: any = "") {
    return this.httpService.post(`admin/medscheck/assessment/save-Key-education-points`, payload);
  }

  getUpdateHistory(payload: any = "") {
    return this.httpService.post(`admin/status/update_history`, payload);
  }

  mergeSearch(payload: any = "") {
    return this.httpService.post(`admin/merge/search`, payload);
  }

  mergeProcess(payload: any = "") {
    return this.httpService.post(`admin/merge/process`, payload);
  }
  updateFilledSatus(payload: any = "") {
    return this.httpService.post(`admin/prescription/update_filled_status`, payload);
  }

  prescriptionStatusTiaHealth(payload: any = "") {
    return this.httpService.post(`admin/prescription-status-list-tia-health`, payload);
  }
  
  updateUserWithRcFaxes(payload: any = "") {
    return this.httpService.post(`admin/user/rc/update_user_with_rc_faxes`, payload);
  }
  
  updateDiaUserFaxes(payload: any = "") {
    return this.httpService.post(`admin/user/rc/confirm-map-dialogue-fax`, payload);
  }

  ring_central_list(payload: any) {
    return this.httpService.post(`admin/user/rc/get_pending_faxes_from_pillexchange`, payload);
  }

  sendRCPrescriptionToTenant(payload: any) {
    return this.httpService.post(`admin/user/rc/send_rc_presctition_to_tenant`, payload);
  }

  map_dialouge_fax(payload: any) {
    return this.httpService.post(`admin/user/rc/map-dialouge-fax`, payload);
  }

  get_drug_list(payload: any) {
    return this.httpService.post(`admin/user/rc/prescription_medication`, payload);
  }
  
  updateDrug(payload: any) {
    return this.httpService.post(`admin/user/rc/edit_fax_medication`, payload);
  }
  
  updateRevertPres(payload: any) {
    return this.httpService.post(`admin/user/rc/revert_fax_mapping`, payload);
  }

  updateRevertDialoguePres(payload: any) {
    return this.httpService.post(`admin/user/rc/dialouge_revert_fax_mapping`, payload);
  }

  view_fax_detail(payload: any) {
    return this.httpService.post(`admin/user/rc/view_fax_detail`, payload);
  }
  
  move_to_archive(payload: any) {
    return this.httpService.post(`admin/user/rc/move_to_archive`, payload);
  }

  get_types_list() {
    return this.httpService.get(`admin/user/rc/prescription_type_list`);
  } 
  
  get_provincve_list(payload: any) {
    return this.httpService.post(`admin/get/state-list`, payload);
  } 
  
  update_pres_type(payload: any) {
    return this.httpService.post(`admin/user/rc/update_prescription_type`, payload);
  }

  confirm_rx_id(payload: any) {
    return this.httpService.post(`admin/user/rc/map_transfer_presctition_to_tenant`, payload);
  }

  confirm_call(payload: any) {
    return this.httpService.post(`admin/user/confirm_call`, payload);
  }

  confirm_match_transfer(payload: any) {
    return this.httpService.post(`admin/user/rc/transfer_presctition_confirm_match`, payload);
  }
  
  transfer_revert_fax_mapping(payload: any) {
    return this.httpService.post(`admin/user/rc/transfer_revert_fax_mapping`, payload);
  }

  get_tenant_type_list(payload: any) {
    return this.httpService.post(`admin/user/rc/prescription-type`, payload);
  }

  get_upload_and_faxes_status(payload: any) {
    return this.httpService.post(`admin/prescription/upload-and-faxes-status`, payload);
  }

}
